
// Actions
const PREFIX = 'calculus/settings/';

export const SET_SETTINGS  = PREFIX + 'SET_SETTINGS';

export const ADD  = PREFIX + 'ADD';
export const PATCH  = PREFIX + 'PATCH';
export const REMOVE  = PREFIX + 'REMOVE';
export const PATCH_SETTINGS  = PREFIX + 'PATCH_SETTINGS';


const INITIAL_STATE = {
  loading: true,
  data: []
};

function parseSettings(data) {
  let o = {};
  for (var i = 0; i < data.length; i++) {
    let item = data[i];

    for(var propertyName in item) {
      o[propertyName] = getId(item[propertyName]);
    }
  }
  return o;
}

function getId(value) {
  let id = value.substring(value.lastIndexOf('(id:') + 5, value.lastIndexOf(')'));
  if(id) {
    return id;
  }
  return value;
}

// Reducer
export default function reducer(state = { ...INITIAL_STATE }, action = {}) {
  const { type, payload } = action;

  switch (type) {
    case SET_SETTINGS:

      let o = parseSettings(payload);

      return {
        ...state,
        data: payload,
        loading: false,
        ...o
      };

    default:
      return state;
  }
}

// Action Creators
export function setSettings(payload) {
  return {
    type: SET_SETTINGS,
    payload: payload
  };
}


// Action Creators
export function add(payload) {
  return {
    type: ADD,
    payload: payload
  };
}

export function patch(payload) {
  return {
    type: PATCH,
    payload: payload
  };
}

export function remove(payload) {
  return {
    type: REMOVE,
    payload: payload
  };
}

export function patchSettings(payload = null) {
  return {
    type: PATCH_SETTINGS,
    payload: payload
  };
}
